import React, { useEffect } from 'react';

const PostDirectionalLink = ({ categories }) => {
  const getTextOnElement = (el) => {
    return el.innerText;
  };

  const nextSiblings = (elem) => {
    // create an empty array
    let siblings = [];

    // loop through next siblings until `null`
    while ((elem = elem.nextElementSibling)) {
      // push sibling to array
      siblings.push(elem);
    }
    return siblings;
  };

  const insertConfigHeading2No2 = () => {
    if (categories.includes(3736)) {
      const firstTagImg = document.getElementById('vnrPostDetail').getElementsByTagName('img')[0];
      if (!firstTagImg) {
        return;
      }
      const parentNode = firstTagImg.parentNode;
      if (!parentNode) {
        return;
      }
      const nodeConfig = document.getElementById('configHeading2No2');
      if (!nodeConfig) return;
      parentNode?.appendChild(nodeConfig, heading2No2);
      return;
    }

    const heading2No2 = document.getElementById('vnrPostDetail').getElementsByTagName('h2')[1];
    if (!heading2No2) {
      return;
    }
    const { parentNode } = heading2No2;
    const nodeConfig = document.getElementById('configHeading2No2');
    parentNode.insertBefore(nodeConfig, heading2No2);
  };

  const insertLink = async () => {
    try {
      if (typeof window === undefined) return;
      const elPostContent = document.querySelectorAll('#postContentContainer > div');
      const textPostContent = getTextOnElement(elPostContent);
      if (textPostContent?.includes('>> Tham gia Khoá học đầu tư Vàng-Forex Miễn Phí')) {
        return;
      }
      insertConfigHeading2No2();
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    // const setTimeoutInsetLink = setTimeout(async() => {
    //   insertLink();
    // }, 1500);

    const articles_inside_article_wrapper = document.getElementById(
      'articles_inside_article_wrapper'
    );
    if (articles_inside_article_wrapper) {
      const contentItems = document.querySelectorAll('#postContentContainer > div > p');
      let middleContentIndex = Math.round(contentItems.length / 3) + 1;
      let middleContentItem = contentItems[middleContentIndex];
      while (
        middleContentIndex < contentItems.length &&
        middleContentItem.previousElementSibling.getElementsByTagName('img').length !== 0
      ) {
        middleContentIndex += 1;
        middleContentItem = contentItems[middleContentIndex];
      }
      if (middleContentIndex === contentItems.length) {
        middleContentIndex = Math.round(contentItems.length / 3) + 1;
        middleContentItem = contentItems[middleContentIndex];
      }

      const bannerInside = document.getElementById('articles_inside_article_wrapper');
      middleContentItem?.parentElement.insertBefore(bannerInside, middleContentItem);
      
      nextSiblings(bannerInside).forEach((ele) =>
        document.getElementById('contentAfterBannerInsideArticle')?.appendChild(ele)
      );
    }

    // return () => {
    //   clearTimeout(setTimeoutInsetLink);
    // };
  }, []);

  return <div></div>;
};

export default PostDirectionalLink;
